import Swiper from 'swiper';

export default class {
    constructor({
        id,
    }) {
        const el = document.getElementById(id);
		
		const mapDesktop = el.querySelector('.recent-releases-interactive-map__desktop');
        const svgDesktop = mapDesktop.querySelector('svg');
        const linksDesktop = svgDesktop ? svgDesktop.querySelectorAll('a') : [];
        const propertiesDesktop = mapDesktop.querySelectorAll('li');
		const propertyCloseButtonsDesktop = mapDesktop.querySelectorAll('.recent-releases-interactive-map__listing-close-btn');

		const mapMobile = el.querySelector('.recent-releases-interactive-map__mobile');
		const svgMobile = mapMobile.querySelector('svg');
		const linksMobile = svgMobile ? svgMobile.querySelectorAll('a') : [];
		const scrollMap = mapMobile.querySelector('.recent-releases-interactive-map__map');
		const scrollbar = mapMobile.querySelector('.recent-releases-interactive-map__scrollbar');
		const scrollbarTrack = scrollbar.querySelector('.recent-releases-interactive-map__scrollbar-track');
		const scrollbarThumb = scrollbar.querySelector('.recent-releases-interactive-map__scrollbar-thumb');
		const propertiesMobile = mapMobile.querySelectorAll('li');
		const propertiesSwiper = mapMobile.querySelector('.recent-releases-interactive-map__listings');

		linksDesktop.forEach((link) => {
			link.addEventListener('click', (e) => {
				propertiesDesktop.forEach(property => {
					e.preventDefault();
					const action = property.dataset.lot === e.target.id.split('-')[1] ? 'toggle' : 'remove';
					property.classList[action]('recent-releases-interactive-map__listing--active');
				});
				linksDesktop.forEach((link) => {
					if (link.id === e.target.id.split('-')[1]) {
						if (link.getAttribute('data-active') === 'active') {
							link.removeAttribute('data-active');
						} else {
							link.setAttribute('data-active', 'active');
						}
					} else {
						link.removeAttribute('data-active');
					}
				});
			});
		});

		propertyCloseButtonsDesktop.forEach((btn) => {
			btn.addEventListener('click', () => {
				propertiesDesktop.forEach(property => property.classList.remove('recent-releases-interactive-map__listing--active'));
				linksDesktop.forEach((link) => link.removeAttribute('data-active'));
			});
		});

		let leftValue = 0;
		let isDragging = false;
		let startX, touchStartX;

		 // Unified function to handle drag start (mouse or touch)
		const handleDragStart = (e) => {
			isDragging = true;
			startX = (e.touches ? e.touches[0].pageX : e.pageX) - scrollbarThumb.offsetLeft;
			document.body.style.userSelect = 'none'; // Prevent text selection
		};

		// Unified function to handle drag move (mouse or touch)
		const handleDragMove = (e) => {
			if (!isDragging) return;
			e.preventDefault();
			const pageX = e.touches ? e.touches[0].pageX : e.pageX;
			const x = pageX - scrollbarTrack.offsetLeft;
			const maxScroll = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
			const newLeft = Math.min(Math.max(0, x - startX), maxScroll);
			scrollbarThumb.style.left = `${newLeft}px`;

			// Update leftValue as a percentage (0 to 60%)
			leftValue = (newLeft / maxScroll) * 60;

			// Scroll the map proportionally
			scrollMap.style.left = `${-leftValue}%`;
		};

		// Unified function to handle drag end (mouse or touch)
		const handleDragEnd = () => {
			isDragging = false;
			document.body.style.userSelect = ''; // Re-enable text selection
		};

		// Add event listeners for both mouse and touch
		scrollbarThumb.addEventListener('mousedown', handleDragStart);
		scrollbarThumb.addEventListener('touchstart', handleDragStart);

		document.addEventListener('mousemove', handleDragMove);
		document.addEventListener('touchmove', handleDragMove);

		document.addEventListener('mouseup', handleDragEnd);
		document.addEventListener('touchend', handleDragEnd);

		// Handle swipe gestures for the map
		scrollMap.addEventListener('touchstart', (e) => {
			touchStartX = e.touches[0].pageX;
		});

		scrollMap.addEventListener('touchmove', (e) => {
			e.preventDefault();
			const touchX = e.touches[0].pageX;
			const deltaX = touchStartX - touchX;
			touchStartX = touchX;

			const maxScroll = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
			const newLeftValue = Math.min(Math.max(0, leftValue + (deltaX / scrollMap.offsetWidth) * 60), 60);

			leftValue = newLeftValue;
			scrollMap.style.left = `${-leftValue}%`;

			// Update scrollbar thumb position
			const newThumbLeft = (leftValue / 60) * maxScroll;
			scrollbarThumb.style.left = `${newThumbLeft}px`;
		});

		// Set the default lot and position the scroll bar and map
		const defaultLot = propertiesMobile[0].dataset.lot;

		const updateActiveMapPos = (lotNumber) => {
			scrollMap.classList.add('smooth-scroll');
			setTimeout(() => {
				scrollMap.classList.remove('smooth-scroll');
			}, 1000);
			linksMobile.forEach((link) => {
				if (link.id === lotNumber) {
					link.setAttribute('data-active', 'active');
					const linkRect = link.getBoundingClientRect().right;
					const offsetRight = linkRect - scrollMap.getBoundingClientRect().left;
					if (offsetRight) {
						const mapWidth = scrollMap.offsetWidth;
						const markerPosition = offsetRight / mapWidth * 100; // Calculate as a percentage
						const maxScroll = scrollbarTrack.offsetWidth - scrollbarThumb.offsetWidth;
	
						// Calculate the left value as a percentage to center the marker
						leftValue = Math.min(Math.max(0, markerPosition - 50), 60); // Center marker within bounds
	
						// Scroll the map to bring the marker into view
						scrollMap.style.left = `${-leftValue}%`;
	
						// Update scrollbar thumb position
						const newThumbLeft = (leftValue / 60) * maxScroll;
						scrollbarThumb.style.left = `${newThumbLeft}px`;
					}
				}
			});
		}

		updateActiveMapPos(defaultLot);

		const updateActiveLot = (lot) => {
			linksMobile.forEach(link => link.removeAttribute('data-active'));
			linksMobile.forEach(link => {
				if (link.id === lot) {
					link.setAttribute('data-active', 'active');
				}
			});
		}
		
		const mySwiper = new Swiper(propertiesSwiper, { // eslint-disable-line no-new
			pagination: {
				el: '.recent-releases-interactive-map__pagination',
				clickable: true,
			},
			spaceBetween: 16,
			on: {
				slideChange: function () {
					updateActiveLot(this.slides[this.activeIndex].dataset.lot);
					updateActiveMapPos(this.slides[this.activeIndex].dataset.lot);
				},
			},
		});

		linksMobile.forEach((link, index) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				linksMobile.forEach(link => link.removeAttribute('data-active'));
				link.setAttribute('data-active', 'active');
				mySwiper.slideTo(index);
			});
		});
    }
}
